<template>
  <md-popup
      class="share-dialog"
      :value="show"
      :closable="false"
      :mask-closable="false"
      position="bottom"
  >
    <header>
      <span>{{ $t('shareToFriend') }}</span>
      <img @click="$emit('close')" src="./assets/close.png" alt="">
    </header>

    <div class="friends-wrap">
      <div class="friends-item" :class="{active: selected.includes(item.account)}" @click="toggleAccount(item.account)"
           v-for="item in friends" :key="item.account">
        <img class="avatar" :src="getTargetUserInfo(item.account).avatar" alt="">
        <img v-show="selected.includes(item.account)" src="./assets/selected-friends.png" alt="" class="selected">
        <span>{{ getTargetUserInfo(item.account).nick }}</span>
      </div>

      <div class="no-friends" v-if="!friends.length">{{ $t('noFriends') }}</div>
    </div>

    <div class="btn-wrap" v-show="selected.length">
      <div class="cancel" @click="$emit('close')">{{ $t('cancel') }}</div>
      <div class="confirm" @click="send">{{ $t('commentSend') }}</div>
    </div>
  </md-popup>
</template>

<script>
export default {
  name: 'Share',
  model: {
    prop: 'show'
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    shareData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState('message', ['friends']),
    ...mapGetters('message', ['getTargetUserInfo'])
  },
  data () {
    return {
      selected: []
    };
  },
  watch: {
    show () {
      this.selected = [];
    }
  },
  created () {
  },
  methods: {
    ...mapActions('message', ['sendCustomMsg']),
    send () {
      if (this.shareData && this.selected.length) {
        this.selected.forEach(item => {
          this.sendCustomMsg({
            msg: this.shareData,
            type: this.shareData.type,
            accid: item
          });
          if ([1006, 1007, 1008].includes(this.shareData.type)) {
            this.$toast.succeed(this.$t('shareSucceed'));
          }
        });
      }
      this.$emit('close');
    },
    toggleAccount (account) {
      const index = this.selected.indexOf(account);
      if (index > -1) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(account);
      }
    }
  }
};
</script>

<style lang="scss">
.share-dialog {
  z-index: 99999;

  .md-popup-box {
    width: 375px !important;
    background-color: white;
    padding: 5px 20px 58px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

    .btn-wrap {
      display: flex;
      justify-content: space-between;
      margin-top: 33px;
      width: 100%;

      div {
        width: 168px;
        height: 32px;
        border-radius: 2px;
        font-family: 'PingFang SC';
        font-weight: 500;
        font-size: 13px;
        color: #161616;
        display: flex;
        align-items: center;
        background-color: #F0F0F0;
        justify-content: center;

        &:nth-child(2) {
          margin-left: 8px;
          background: #32B8AF;
          color: white;
        }
      }
    }

    .friends-wrap {
      display: flex;
      overflow-x: auto;
      width: 100%;

      .no-friends {
        text-align: center;
        width: 100%;
      }

      .friends-item {
        position: relative;
        width: 68px;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &:not(:last-child) {
          margin-right: 10px;
        }

        &.active {
          .avatar {
            opacity: 0.4;
          }
        }

        .selected {
          width: 16px;
          height: 16px;
          top: 26px;
          position: absolute;
          left: 26px;
        }

        .avatar {
          width: 42px;
          height: 42px;
          border-radius: 100%;
          margin-bottom: 8px;
        }

        span {
          display: block;
          width: 100%;
          white-space: nowrap;
          overflow-x: hidden;
          text-overflow: ellipsis;
          text-align: center;
        }

      }

    }

    header {
      height: 24px;
      display: flex;
      margin-bottom: 16px;
      justify-content: space-between;

      span {
        font-family: 'PingFang SC';
        font-weight: 500;
        font-size: 12px;
        color: #161616;
      }

      img {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
